import { createSlice } from '@reduxjs/toolkit';

const reportSlice = createSlice({
  name: 'reports',
  initialState: {
    oldData: 0, // O for New and 1 for History (out patient)
    inPatient: 0, // O for all except (laboratory-results, radiology-results, cardiology-results, discharge-summary-reports (in-patient reports))
    selectedReportType: null
  },
  reducers: {
    handleUpdateReportData(state, action) {
      state.oldData = action.payload.old;
      state.inPatient = action.payload.inPat;
    },
    handleUpdateReportType(state, action) {
      state.selectedReportType = action.payload;
    }
  },
});

export const selectReports= (state) => state.reports;

export default reportSlice;
